import { ApiService } from './../../api.service';
import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-corider-rides-requests',
  templateUrl: './corider-rides-requests.component.html',
  styleUrls: ['./corider-rides-requests.component.scss']
})
export class CoriderRidesRequestsComponent implements OnInit {

  isRequesting = false;
  requestsForTrip: any;
  id: any;
  constructor(
    public api: ApiService,
    private titleService: Title,
    private route: ActivatedRoute,
    public snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    this.titleService.setTitle('Autoscoop - Mates Ride Request');
    this.route.params.subscribe(params => {
      this.id = +params.id;
      this.getRequestForRideByID(+params.id);
    });
  }

  getRequestForRideByID(rideId: any) {
    this.api.getRequestsByRideId(rideId).subscribe(
      r => {
        // console.log(r);
        this.requestsForTrip = r;
        this.isRequesting = false;
      },
      error => {
        this.isRequesting = false;
        console.log(error);
      }
    );
  }

  approveRequest(request) {
    request.requestStatus = 'Approved';
    this.api.approveTripRequest(request).subscribe(r => {
      console.log(r);
      this.snackBar.open('The trip has been Approved successfully.', '', {
        duration: 5000
      });
      this.requestsForTrip.forEach(element => {
        if (element.rideRequestId === request.rideRequestId) {
          element.requestStatus = 'Approved';
        }
      });
    });
  }

  denyRequest(request) {
    request.requestStatus = 'Denied';
    this.api.approveTripRequest(request).subscribe(r => {
      console.log(r);
      this.snackBar.open('The trip has been Denied successfully.', '', {
        duration: 5000
      });
      this.requestsForTrip.forEach(element => {
        if (element.rideRequestId === request.rideRequestId) {
          element.requestStatus = 'Denied';
        }
      });
    });
  }

}
